import { Ammo } from '../physics'
import { physicsWorld, rigidBodies } from '../physics'
import { scene } from '../utils'
import state from '../state'
import * as THREE from 'three'

export function createParalellepiped(sx, sy, sz, mass, pos, quat, material) {
  const threeObject = new THREE.Mesh(
    new THREE.BoxBufferGeometry(sx, sy, sz, 1, 1, 1),
    material,
  )
  const shape = new Ammo.btBoxShape(
    new Ammo.btVector3(sx * 0.5, sy * 0.5, sz * 0.5),
  )
  shape.setMargin(state.physics.margin)

  createRigidBody(threeObject, shape, mass, pos, quat)

  return threeObject
}

export function createRigidBody(threeObject, physicsShape, mass, pos, quat) {
  threeObject.position.copy(pos)
  threeObject.quaternion.copy(quat)

  const transform = new Ammo.btTransform()
  transform.setIdentity()
  transform.setOrigin(new Ammo.btVector3(pos.x, pos.y, pos.z))
  transform.setRotation(new Ammo.btQuaternion(quat.x, quat.y, quat.z, quat.w))
  const motionState = new Ammo.btDefaultMotionState(transform)

  const localInertia = new Ammo.btVector3(0, 0, 0)
  physicsShape.calculateLocalInertia(mass, localInertia)

  const rbInfo = new Ammo.btRigidBodyConstructionInfo(
    mass,
    motionState,
    physicsShape,
    localInertia,
  )
  const body = new Ammo.btRigidBody(rbInfo)

  threeObject.userData.physicsBody = body
  scene.add(threeObject)

  if (mass > 0) {
    rigidBodies.push(threeObject)

    // Disable deactivation
    body.setActivationState(4)
  }

  physicsWorld.addRigidBody(body)
}

export function createRandomColor() {
  return Math.floor(Math.random() * (1 << 24))
}

export function createMaterial() {
  return new THREE.MeshPhongMaterial({ color: createRandomColor() })
}
